/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ExhibitionPageEventPropertyType {
    String = 'string',
    Boolean = 'boolean',
    Number = 'number',
    Color = 'color'
}

export function ExhibitionPageEventPropertyTypeFromJSON(json: any): ExhibitionPageEventPropertyType {
    return ExhibitionPageEventPropertyTypeFromJSONTyped(json, false);
}

export function ExhibitionPageEventPropertyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExhibitionPageEventPropertyType {
    return json as ExhibitionPageEventPropertyType;
}

export function ExhibitionPageEventPropertyTypeToJSON(value?: ExhibitionPageEventPropertyType | null): any {
    return value as any;
}

